import Rest from './rest';

const RESOURCE = "vehicle";

export default {

    filterVehicles: function (params) {
        return Rest.get(RESOURCE, {params})
    },
    getVehicle: function (vehicleId) {
        return Rest.get(`${RESOURCE}/${vehicleId}`);
    },
    addVehicle: function (data) {
        return Rest.post(RESOURCE, data);
    },
    updateVehicle: function (vehicleId, data) {
        return Rest.put(`${RESOURCE}/${vehicleId}`, data);
    },
    toggleVehicleState: function (vehicleId, status) {
        return Rest.patch(`${RESOURCE}/${vehicleId}`,null, {params: {status}});
    },
};



// WEBPACK FOOTER //
// ./src/services/VehicleService.js